module.exports = __webpack_public_path__ + "static/img/success_logo.26d6913e.webp";